import { render, staticRenderFns } from "./accountEntrust.vue?vue&type=template&id=0826cfc4&scoped=true&"
import script from "./accountEntrust.vue?vue&type=script&lang=js&"
export * from "./accountEntrust.vue?vue&type=script&lang=js&"
import style0 from "./accountEntrust.vue?vue&type=style&index=0&id=0826cfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826cfc4",
  null
  
)

export default component.exports